import { Box, Sphere } from '@awayjs/core';
import { HitTestCache } from './HitTestCache';
var LineElementsUtils = /** @class */ (function () {
    function LineElementsUtils() {
    }
    //TODO - generate this dyanamically based on num tris
    LineElementsUtils.hitTest = function (x, y, z, thickness, box, lineElements, count, offset) {
        if (offset === void 0) { offset = 0; }
        var positionAttributes = lineElements.positions;
        var posStride = positionAttributes.stride;
        var positions = positionAttributes.get(count, offset);
        var indices;
        var len;
        if (lineElements.indices) {
            indices = lineElements.indices.get(count, offset);
            positions = positionAttributes.get(positionAttributes.count);
            len = count * lineElements.indices.dimensions;
        }
        else {
            positions = positionAttributes.get(count, offset);
            len = count;
        }
        var id0;
        var id1;
        var ax;
        var ay;
        var bx;
        var by;
        var hitTestCache = lineElements.hitTestCache[offset] || (lineElements.hitTestCache[offset] = new HitTestCache());
        var index = hitTestCache.lastCollisionIndex;
        if (index != -1 && index < len) {
            precheck: {
                if (indices) {
                    id0 = indices[index] * posStride;
                    id1 = indices[index + 1] * posStride;
                }
                else {
                    id0 = index * posStride;
                    id1 = (index + 1) * posStride;
                }
                ax = positions[id0];
                ay = positions[id0 + 1];
                bx = positions[id1];
                by = positions[id1 + 1];
                //from a to p
                var dx = ax - x;
                var dy = ay - y;
                //edge normal (a-b)
                var nx = by - ay;
                var ny = -(bx - ax);
                var D = Math.sqrt(nx * nx + ny * ny);
                //TODO: should strictly speaking be an elliptical calculation, use circle to approx temp
                if (Math.abs((dx * nx) + (dy * ny)) > thickness * D)
                    break precheck;
                //edge vector
                var dot = (dx * ny) - (dy * nx);
                if (dot > D * D || dot < 0)
                    break precheck;
                return true;
            }
        }
        //hard coded min vertex count to bother using a grid for
        if (len > 150) {
            var cells = hitTestCache.cells;
            var divisions = cells.length ? hitTestCache.divisions : (hitTestCache.divisions = Math.min(Math.ceil(Math.sqrt(len)), 32));
            var conversionX = divisions / box.width;
            var conversionY = divisions / box.height;
            var minx = box.x;
            var miny = box.y;
            if (!cells.length) { //build grid
                //now we have bounds start creating grid cells and filling
                cells.length = divisions * divisions;
                for (var k = 0; k < len; k += 3) {
                    if (indices) {
                        id0 = indices[k] * posStride;
                        id1 = indices[k + 1] * posStride;
                    }
                    else {
                        id0 = k * posStride;
                        id1 = (k + 1) * posStride;
                    }
                    ax = positions[id0];
                    ay = positions[id0 + 1];
                    bx = positions[id1];
                    by = positions[id1 + 1];
                    //subtractions to push into positive space
                    var min_index_x = Math.floor((Math.min(ax, bx) - minx) * conversionX);
                    var min_index_y = Math.floor((Math.min(ay, by) - miny) * conversionY);
                    var max_index_x = Math.floor((Math.max(ax, bx) - minx) * conversionX);
                    var max_index_y = Math.floor((Math.max(ay, by) - miny) * conversionY);
                    for (var i = min_index_x; i <= max_index_x; i++) {
                        for (var j = min_index_y; j <= max_index_y; j++) {
                            var c = i + j * divisions;
                            var nodes = cells[c] || (cells[c] = new Array());
                            //push in the triangle ids
                            nodes.push(k);
                        }
                    }
                }
            }
            var index_x = Math.floor((x - minx) * conversionX);
            var index_y = Math.floor((y - miny) * conversionY);
            var nodes = cells[index_x + index_y * divisions];
            if (nodes == null) {
                hitTestCache.lastCollisionIndex = -1;
                return false;
            }
            var nodeCount = nodes.length;
            for (var n = 0; n < nodeCount; n++) {
                var k = nodes[n];
                if (indices) {
                    id0 = indices[k] * posStride;
                    id1 = indices[k + 1] * posStride;
                }
                else {
                    id0 = k * posStride;
                    id1 = (k + 1) * posStride;
                }
                ax = positions[id0];
                ay = positions[id0 + 1];
                bx = positions[id1];
                by = positions[id1 + 1];
                //from a to p
                var dx = ax - x;
                var dy = ay - y;
                //edge normal (a-b)
                var nx = by - ay;
                var ny = -(bx - ax);
                var D = Math.sqrt(nx * nx + ny * ny);
                //TODO: should strictly speaking be an elliptical calculation, use circle to approx temp
                if (Math.abs((dx * nx) + (dy * ny)) > thickness * D)
                    continue;
                //edge vector
                var dot = (dx * ny) - (dy * nx);
                if (dot > D * D || dot < 0)
                    continue;
                hitTestCache.lastCollisionIndex = k;
                return true;
            }
            hitTestCache.lastCollisionIndex = -1;
            return false;
        }
        //brute force
        for (var k = 0; k < len; k += 6) {
            if (indices) {
                id0 = indices[k] * posStride;
                id1 = indices[k + 1] * posStride;
            }
            else {
                id0 = k * posStride;
                id1 = (k + 1) * posStride;
            }
            ax = positions[id0];
            ay = positions[id0 + 1];
            bx = positions[id1];
            by = positions[id1 + 1];
            //from a to p
            var dx = ax - x;
            var dy = ay - y;
            //edge normal (a-b)
            var nx = by - ay;
            var ny = -(bx - ax);
            var D = Math.sqrt(nx * nx + ny * ny);
            //TODO: should strictly speaking be an elliptical calculation, use circle to approx temp
            if (Math.abs((dx * nx) + (dy * ny)) > thickness * D)
                continue;
            //edge vector
            var dot = (dx * ny) - (dy * nx);
            if (dot > D * D || dot < 0)
                continue;
            hitTestCache.lastCollisionIndex = k;
            return true;
        }
        hitTestCache.lastCollisionIndex = -1;
        return false;
    };
    LineElementsUtils.getBoxBounds = function (positionAttributes, indexAttributes, matrix3D, thicknessScale, cache, target, count, offset) {
        if (offset === void 0) { offset = 0; }
        var positions;
        var posDim = positionAttributes.dimensions;
        var posStride = positionAttributes.stride;
        var minX = 0, minY = 0, minZ = 0;
        var maxX = 0, maxY = 0, maxZ = 0;
        var indices;
        var len;
        if (indexAttributes) {
            len = count * indexAttributes.dimensions;
            indices = indexAttributes.get(count, offset);
            positions = positionAttributes.get(positionAttributes.count);
        }
        else {
            len = count;
            positions = positionAttributes.get(count, offset);
        }
        if (len == 0)
            return target;
        var i = 0;
        var index;
        var pos1, pos2, pos3, rawData;
        if (matrix3D)
            rawData = matrix3D._rawData;
        for (var i = 0; i < len; i += 3) {
            index = (indices) ? indices[i] * posStride : i * posStride;
            if (matrix3D) {
                if (posDim == 6) {
                    pos1 = positions[index] * rawData[0] + positions[index + 1] * rawData[4] + positions[index + 2] * rawData[8] + rawData[12];
                    pos2 = positions[index] * rawData[1] + positions[index + 1] * rawData[5] + positions[index + 2] * rawData[9] + rawData[13];
                    pos3 = positions[index] * rawData[2] + positions[index + 1] * rawData[6] + positions[index + 2] * rawData[10] + rawData[14];
                }
                else {
                    pos1 = positions[index] * rawData[0] + positions[index + 1] * rawData[4] + rawData[12];
                    pos2 = positions[index] * rawData[1] + positions[index + 1] * rawData[5] + rawData[13];
                }
            }
            else {
                pos1 = positions[index];
                pos2 = positions[index + 1];
                pos3 = (posDim == 6) ? positions[index + 2] : 0;
            }
            if (i == 0) {
                maxX = minX = pos1;
                maxY = minY = pos2;
                maxZ = minZ = (posDim == 6) ? pos3 : 0;
            }
            else {
                if (pos1 < minX)
                    minX = pos1;
                else if (pos1 > maxX)
                    maxX = pos1;
                if (pos2 < minY)
                    minY = pos2;
                else if (pos2 > maxY)
                    maxY = pos2;
                if (posDim == 6) {
                    if (pos3 < minZ)
                        minZ = pos3;
                    else if (pos3 > maxZ)
                        maxZ = pos3;
                }
            }
        }
        var box = new Box(minX, minY);
        box.right = maxX;
        box.bottom = maxY;
        this.mergeThinkness(box, thicknessScale, matrix3D);
        return box.union(target, target || cache);
    };
    LineElementsUtils.mergeThinkness = function (target, thicknessScale, matrix3D) {
        var _a;
        var rawData = (_a = matrix3D) === null || _a === void 0 ? void 0 : _a._rawData;
        var thicknessX = matrix3D
            ? thicknessScale.x * rawData[0] + thicknessScale.y * rawData[4]
            : thicknessScale.x;
        var thicknessY = matrix3D
            ? thicknessScale.x * rawData[1] + thicknessScale.y * rawData[5]
            : thicknessScale.y;
        target.x -= thicknessX;
        target.y -= thicknessY;
        target.right += thicknessX;
        target.bottom += thicknessY;
        return target;
    };
    LineElementsUtils.getSphereBounds = function (positionAttributes, center, matrix3D, cache, output, count, offset) {
        if (offset === void 0) { offset = 0; }
        var positions = positionAttributes.get(count, offset);
        var posDim = positionAttributes.dimensions;
        var posStride = positionAttributes.stride;
        var maxRadiusSquared = 0;
        var radiusSquared;
        var len = count * posStride;
        var distanceX;
        var distanceY;
        var distanceZ;
        for (var i = 0; i < len; i += posStride) {
            distanceX = positions[i] - center.x;
            distanceY = positions[i + 1] - center.y;
            distanceZ = (posDim == 6) ? positions[i + 2] - center.z : -center.z;
            radiusSquared = distanceX * distanceX + distanceY * distanceY + distanceZ * distanceZ;
            if (maxRadiusSquared < radiusSquared)
                maxRadiusSquared = radiusSquared;
        }
        if (output == null)
            output = new Sphere();
        output.x = center.x;
        output.y = center.y;
        output.z = center.z;
        output.radius = Math.sqrt(maxRadiusSquared);
        return output;
    };
    return LineElementsUtils;
}());
export { LineElementsUtils };
